import { z } from "zod";

export const ConvexNotificationCreateResponseSchema = z.object({
  notification_id: z.string(),
  recipient_ids: z.array(z.string()),
});
export type ConvexNotificationCreateResponse = z.infer<typeof ConvexNotificationCreateResponseSchema>;

export const NotificationEmailDispatchResultSchema = z.object({
  notification_id: z.string(),
  recipients_count: z.number().int().nonnegative(),
  emails_queued: z.number().int().nonnegative(),
});
export type NotificationEmailDispatchResult = z.infer<typeof NotificationEmailDispatchResultSchema>;

export const NotificationEmailDispatchEnvelopeSchema = z.object({
  data: NotificationEmailDispatchResultSchema,
});

export const NotificationEmailDispatchResponseSchema = z.union([
  NotificationEmailDispatchEnvelopeSchema,
  NotificationEmailDispatchResultSchema,
]);
export type NotificationEmailDispatchResponse = z.infer<typeof NotificationEmailDispatchResponseSchema>;
